export { default } from '@material-ui/core/ButtonBase';

export type ButtonBaseProps = import('@material-ui/core/ButtonBase').ButtonBaseProps;
